<script setup>
import {ref ,watch} from 'vue'
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { computed, onMounted } from 'vue';
import {getSimpleListApi ,getInfoTypeApi} from "@/api";
const { t } = useI18n();
const store = useStore();
const info = ref({});
function getInfoType (){
  getInfoTypeApi().then(res=>{
    info.value = res.data;
    console.log(info.value,"55")
  })
}
// const navItems = [
//   // { title: t('首页'), href: '/' },
//   { title: t('发展历史'), href: '/HistoryComponent' },
//   { title: t('资质荣誉'), href: '/qualificationsHonors' },
//   { title: t('宣传视频'), href: '/promotionalVideo' },
//   { title: t('客户案例'), href: '/customerCase' },
//   { title: t('下载中心'), href: '/DownloadMessage' },
//   { title: t('联系我们'), href: '/contactUs' },
//   { title: t('在线留言'), href: '/OnlineCenter' }
// ];

const navItems = computed(() => store.getters.getNavItems);

const navItems1 = ref([]);
const navItems2 = ref([]);

watch(
    () => store.getters.getNavItems,
    () => {
      let arr1=[] ,arr2 =[]
      navItems.value.map(e=>{
        if (e.subItems && e.subItems.length > 0 ){
          arr2.push(e)
        }else{
          arr1.push(e)
        }
      })
      navItems1.value = arr1;
      navItems2.value = arr2;
      console.log(arr1, 22 )
      console.log(56,arr2  )
    },
    { deep: true }
);
// 在组件挂载时加载菜单数据
onMounted(async () => {
  try {
    await store.dispatch('loadMenuData', { getSimpleListApi });
  } catch (error) {
    console.error('Failed to load menu data:', error);
  }
});
getInfoType()
</script>

<template>
<div>
  <div id="bottom_main">
    <div id="bottom">
      <div id="bottom_1">
        <!-- 底部导航 开始-->
        <ul class="bottom_navigation">
          <li>
            <div class="pointer">{{t('首页')}}</div>
            <ul class="subnavigationlist1">
              <!-- <li> -->
              <!--   <a href="/yccms/single/zzjg/4.html" target="_self">{{t('发展历史')}}</a> -->
              <!-- </li> -->
              <li v-for="item in navItems1" :key="item.href" v-show="item.status ==0 ">
                <router-link :to="item.href" >{{t(item.title)}}</router-link>
              </li>
              <!-- <li> -->
              <!--   <a href="/yccms/single/ryzz/3.html" target="_self">{{t('资质荣誉')}}</a> -->
              <!-- </li> -->
              <!-- <li> -->
              <!--   <a href="/yccms/video/index/5.html" target="_self">{{t('宣传视频')}}</a> -->
              <!-- </li> -->
              <!-- <li> -->
              <!--   <a href="/yccms/case_show/index/14.html" target="_self">{{t('客户案例')}}</a> -->
              <!-- </li> -->
              <!-- <li> -->
              <!--   <a href="/yccms/download/index/15.html" target="_self">{{t('下载中心')}}</a> -->
              <!-- </li> -->
              <!-- <li> -->
              <!--   <a href="/yccms/single/lxwm/18.html" target="_self">{{t('联系我们')}}</a> -->
              <!-- </li> -->
              <!-- <li> -->
              <!--   <a href="/yccms/single/zxly/17.html" target="_self">{{t('在线留言')}}</a> -->
              <!-- </li> -->
            </ul>
          </li>
          <li v-for="(e,i) in navItems2" :key="i" v-show="e.status ==0 ">
            <div class="pointer">{{t(e.title)}}</div>
            <ul class="subnavigationlist1">
              <li  v-for="item in e.subItems" :key="item.title">
                <router-link :to="item.href" >{{t(item.title)}}</router-link>
              </li>
            </ul>
          </li>
          <!-- <li> -->
          <!--   <div class="pointer">{{t('产品展示')}}</div> -->
          <!--   <ul class="subnavigationlist1"> -->
          <!--     <li v-for="item in productSubItems" :key="item.id"> -->
          <!--       <router-link :to="item.href" >{{item.title}}</router-link> -->


          <!--     </li> -->
          <!--   </ul> -->
          <!-- </li> -->
        </ul>
      </div>
      <div id="bottom_2">
        <div class="contact_wrap">
          <b class="ico5">{{t('联系人')}}：</b> {{info.name}}
          <br>
          <p><b class="ico2">{{t('电话')}} ：</b> {{info.phone}} </p>
          <b class="ico3">{{t('邮箱')}} ：</b> {{info.email}}
          <br>
          <b class="ico4">{{t('地址')}} ：</b> {{info.address}}
          <br>
        </div>
        <div class="WeChat">
          <img :src=" info.codeUrl ">
          <div class="bdsharebuttonbox">
            <span class="LShare">微信扫描关注我们：</span>
            <!--                    <a href="#" class="bds_more" data-cmd="more"></a>-->
            <!--                    <a href="#" class="bds_qzone" data-cmd="qzone" title="分享到QQ空间"></a>-->
            <!--                    <a href="#" class="bds_tsina" data-cmd="tsina" title="分享到新浪微博"></a>-->
            <!--                    <a href="#" class="bds_tqq" data-cmd="tqq" title="分享到腾讯微博"></a>-->
            <!--                    <a href="#" class="bds_renren" data-cmd="renren" title="分享到人人网"></a>-->
            <a href="#" class="bds_weixin" data-cmd="weixin" title="分享到微信"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 底部版权 开始-->
  <div id="copyright_main">
    <div id="copyright">
      <span class="TechnicalSupport">技术支持：<a href="https://www.baidu.com/" target="_blank">某科技公司</a></span>
      <span>
            <a href="https://www.baidu.com/" target="_self">某商务公司</a>
          <p style="display: inline"> &nbsp;版权所有&nbsp; </p>
            <a href="https://www.baidu.com/">ICP备888888888号</a>&nbsp;
        </span>
    </div>
  </div>
</div>
</template>

<style scoped lang="scss">

.bottom_navigation {
  overflow: hidden;
  float: left;
}

.bottom_navigation li {
  float: left;
  width: 120px;
  margin-right: 15px;
  overflow: hidden;
}

.bottom_navigation li  {
  a ,.pointer {
    display: block;
    text-align: left;
    font-size: 18px;
    margin-bottom: 10px;
    color: #000;
  }

}

.bottom_navigation li{
  a:hover ,.pointer:hover {
    color: #666;
  }

}

.bottom_navigation .subnavigationlist1 li {
  float: none;
  padding: 0;
  line-height: 28px;
  display: block;
}

.bottom_navigation .subnavigationlist1 li {
  a ,.pointer {
    color: #444;
    display: block;
    line-height: 30px;
    font-weight: normal;
    padding: 0;
    margin: 0;
    font-size: 13px;
    text-align: left;
  }
}

.bottom_navigation .subnavigationlist1 li{
  a:hover ,.pointer:hover {
    color: #666;
  }
}

</style>